import { FullUserFragment } from "graphql.generated";

export type CustomerEditorField = 'fullName' | 'phone' | 'email' | 'company';
export type AdditionalContactEditorField = 'name' | 'phone' | 'email' | 'relationship';

export const additionalContactInitialState = {
  selectedAdditionalContact: undefined as FullUserFragment | undefined,
  userId: undefined as string | undefined,
  name: '' as string,
  phone: '' as string,
  email: '' as string,
  relationship: '' as string,
  isContactModified: false as boolean,
  isUnlinked: false as boolean,
  focusedField: null as AdditionalContactEditorField | null,
} as const;

export type AdditionalContactState = typeof additionalContactInitialState;

export const jobCreateCustomerInitialState = {
  isCustomerEditMode: false as boolean,
  customerEditor: {
    selectedCustomer: undefined as FullUserFragment | undefined,
    fullName: '' as string,
    phone: '' as string,
    email: '' as string,
    additionalContacts: [] as AdditionalContactState[],
    company: '' as string,
    customerType: '' as string,
    referralSource: '' as string,
    jobOrigin: '' as string,
    suggestedCustomers: {} as Partial<Record<CustomerEditorField, FullUserFragment[]>>,
    isCustomerModified: false as boolean,
    focusedField: null as CustomerEditorField | null,
  },
} as const;

export type JobCreateCustomerState = typeof jobCreateCustomerInitialState;
